import React from 'react';
import './SplashPage.css';
import logoImage from '../assets/splash_image.png';

const SplashPage = () => {

  return (
    <div className="splash-container">
      <div className="content-wrapper">
        <div className="logo-container">
          <img
            src={logoImage}
            alt="Logo"
            className="logo-image"
          />
        </div>
        <div className="text-container">
          <h2 className="bold-text">A game you can play against quantum agents</h2>
          <p className="regular-text">What's a quantum agent? Find out here!</p>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;